export enum PrefecturesEndpointsEnum {
  PREFECTURES_LIST = "/prefectures",
}
